import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

import { KeyboardKeyCode } from '@flowx/designer/modules/bpmn-editor/bpmn-graph.util'
import { AiIconsModule } from '@flowx/designer/modules/new-ai/common/icons/ai-icons.module'

import { ShortcutIconName } from '../../../../common/ai.dictionary'

export enum IconType {
  ICON = 'icon',
  KEY = 'key',
}

export enum AiKeyboardKeyCode {
  CONFIRM = KeyboardKeyCode.CONFIRM,
  GENERATE = KeyboardKeyCode.GENERATE,
  CANCEL = 'esc',
  NEW = 'n',
}

export type ShortcutConfig = {
  label?: string
  icons: { type: IconType; name: ShortcutIconName | string }[]
}

@Component({
  selector: 'flx-ai-shortcut',
  imports: [CommonModule, AiIconsModule],
  templateUrl: './shortcut.component.html',
  styleUrls: ['./shortcut.component.scss'],
})
export class AiShortcutComponent {
  @Input() label?: ShortcutConfig['label']
  @Input() icons: ShortcutConfig['icons']

  IconType = IconType
}
